import { render, staticRenderFns } from "./dialogAlarmTypeInfo.vue?vue&type=template&id=68144dd8&"
import script from "./dialogAlarmTypeInfo.vue?vue&type=script&lang=js&"
export * from "./dialogAlarmTypeInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogAlarmTypeInfo.vue?vue&type=style&index=0&id=68144dd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports